import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import IconCarInclusions from "../../../assets/IconCarInclusions";
import IconAllInclusive from "../../../assets/IconAllInclusive";
import IconTravelInsurance from "../../../assets/IconTravelInsurance";
import InclusionListBlock from "../../commons/inclusionListblock";
import { GroupRates } from "../../../../domain/constants";
import IconAllInclusiveMax from "../../../assets/iconAllInclusiveMax";
import IconBasicPlus from "../../../assets/iconBasicPlus";
import i18next from "i18next";
const RateQualifierGeneralDetails = ({ myData, renters, renter, width, applyDiscount, allInclusiveOffer }) => {
    const { t } = useTranslation();
    const [isHerzt, setIsHerzt] = useState(false);
    const [rentersArray, setRentersArray] = useState([]);
    useEffect(() => {
        if (renter.renterName == "Hertz" || renter.renterName == "Budget" || renter.renterName == "Payless") {
            setIsHerzt(true);
        }
        setRentersArray((prevRentersArray) => {
            // Map renters to an array of names and convert to lowercase
            const newRentersArray = renters.map((renter) => renter.renterName.toLowerCase());
            // Use a Set to keep track of unique names
            const uniqueNamesSet = new Set([...prevRentersArray, ...newRentersArray]);
            // Convert the Set back to an array
            const uniqueNamesArray = Array.from(uniqueNamesSet);
            return uniqueNamesArray;
        });
    }, [renters]);
    const today = new Date();
    const optionsMonth = { month: "short" };
    const optionsDay = { day: "numeric" };
    // Get month and day separately
    const month = today.toLocaleDateString(i18next.language, optionsMonth);
    const day = today.toLocaleDateString(i18next.language, optionsDay);
    // Construct the date string in the desired format
    const todayDate = ` ${month.charAt(0).toUpperCase()}${month.slice(1)} ${day}`;
    let generalDetails = myData.generalDetails[0].category != "" && myData.generalDetails[0].category != undefined
        ? myData.generalDetails
        : [
            {
                "name": "Seguro de colisión y daño interior",
                "code": "1",
                "status": true,
                "translate": [
                    {
                        "language": "EN",
                        "name": "Collision and interior damage insurance"
                    },
                    {
                        "language": "PT",
                        "name": "Seguro contra colisões e danos interiores"
                    }
                ],
                "category": "1-insurance"
            },
            {
                "name": "Seguro contra robo y vandalismo",
                "code": "2",
                "status": true,
                "translate": [
                    {
                        "language": "EN",
                        "name": "Insurance against theft and vandalism"
                    },
                    {
                        "language": "PT",
                        "name": "Seguro contra roubo e vandalismo"
                    }
                ],
                "category": "1-insurance"
            },
            {
                "name": `Seguro de responsabilidad civil de terceros hasta US${isHerzt ? '\$1,000,000' : '\$500,000'} `,
                "code": "3",
                "status": true,
                "extraLabel": "Gratis",
                "translate": [
                    {
                        "language": "EN",
                        "name": `Third party liability insurance up to US${isHerzt ? '\$1,000,000' : '\$500,000'}`,
                        "extraLabel": "Free"
                    },
                    {
                        "language": "PT",
                        "name": `Seguro de responsabilidade civil contra terceiros até US${isHerzt ? '\$1,000,000' : '\$500,000'}`,
                        "extraLabel": "Gratuito"
                    }
                ],
                "category": "1-insurance"
            },
            {
                "name": "Seguro de llantas y llaves perdidas",
                "code": "4",
                "status": true,
                "note": "",
                "translate": [
                    {
                        "language": "EN",
                        "name": "Tire and lost keys insurance"
                    },
                    {
                        "language": "PT",
                        "name": "Pneu perdido e seguro de chave"
                    },
                    {
                        "language": "RA",
                        "name": "Test general"
                    }
                ],
                "category": "1-insurance"
            },
            {
                "name": "Cero deducibles",
                "code": "5",
                "status": true,
                "translate": [
                    {
                        "language": "EN",
                        "name": "No deductibles"
                    },
                    {
                        "language": "PT",
                        "name": "Sem franquia"
                    }
                ],
                "category": "1-insurance"
            },
            {
                "name": "Impuestos y recargos incluidos",
                "code": "6",
                "status": true,
                "translate": [
                    {
                        "language": "EN",
                        "name": "Taxes and surcharges included"
                    },
                    {
                        "language": "PT",
                        "name": "Impostos e sobretaxas incluídos"
                    },
                    {
                        "language": "RA",
                        "name": "a lil test"
                    }
                ],
                "category": "2-inclusions"
            },
            {
                "name": "Conductor adicional sin costo",
                "code": "7",
                "status": true,
                "translate": [
                    {
                        "language": "EN",
                        "name": "Additional driver free of charge"
                    },
                    {
                        "language": "PT",
                        "name": "Motorista adicional sem custo"
                    }
                ],
                "category": "2-inclusions"
            },
            {
                "name": "Cancelación sin penalidades (48 horas)",
                "code": "8",
                "status": true,
                "translate": [
                    {
                        "language": "EN",
                        "name": "Cancellation without penalties (48 hours)"
                    },
                    {
                        "language": "PT",
                        "name": "Cancelamento sem penalidades (48 horas)"
                    }
                ],
                "category": "2-inclusions"
            },
            {
                "name": "Asistencia en carretera 24/7",
                "code": "9",
                "status": true,
                "translate": [
                    {
                        "language": "EN",
                        "name": "24/7 Roadside Assistance"
                    },
                    {
                        "language": "PT",
                        "name": "Assistência rodoviária 24/7"
                    }
                ],
                "category": "2-inclusions"
            },
            {
                "name": "Kilometraje ilimitado",
                "code": "10",
                "status": true,
                "translate": [
                    {
                        "language": "EN",
                        "name": "Unlimited mileage"
                    },
                    {
                        "language": "PT",
                        "name": "Quilometragem ilimitada"
                    }
                ],
                "category": "2-inclusions"
            },
            {
                "name": "Política de combustible: Lleno a Lleno",
                "code": "11",
                "status": true,
                "translate": [
                    {
                        "language": "EN",
                        "name": "Fuel Policy: Full to Full"
                    },
                    {
                        "language": "PT",
                        "name": "Política de Combustível: Cheio a Cheio"
                    }
                ],
                "category": "2-inclusions"
            },
            {
                "name": "Cash back del costo de peajes",
                "code": "12",
                "status": true,
                "extraLabel": "Gratis",
                "blockByIp": true,
                "translate": [
                    {
                        "language": "EN",
                        "name": "Cash back on toll costs",
                        "extraLabel": "Free"
                    },
                    {
                        "language": "PT",
                        "name": "Reembolso de custos de pedágio",
                        "extraLabel": "Gratuito"
                    }
                ],
                "category": "2-inclusions"
            },
            {
                "name": "Seguro de viaje con cobertura médica de US$150.000",
                "code": "13",
                "status": true,
                "extraLabel": "Gratis",
                "translate": [
                    {
                        "language": "EN",
                        "name": "Travel insurance with medical coverage of US$150,000",
                        "extraLabel": "Free"
                    },
                    {
                        "language": "PT",
                        "name": "Seguro de viagem com cobertura médica de US$ 150 mil",
                        "extraLabel": "Gratuito",
                    }
                ],
                "category": "3-asistence"
            },
            {
                "name": "Cubre a todas las personas del núcleo familiar",
                "code": "14",
                "status": true,
                "translate": [
                    {
                        "language": "EN",
                        "name": "Covers all members of the family unit"
                    },
                    {
                        "language": "PT",
                        "name": "Abrange todas as pessoas do núcleo familiar"
                    }
                ],
                "category": "3-asistence"
            },
            {
                "name": "Seguro de cancelación de vuelo US$1.500",
                "code": "15",
                "status": true,
                "translate": [
                    {
                        "language": "EN",
                        "name": "Flight cancellation insurance US$1,500"
                    },
                    {
                        "language": "PT",
                        "name": "Seguro de cancelamento de voo US$ 1.500"
                    }
                ],
                "category": "3-asistence"
            },
            {
                "name": "Compensación pérdida equipaje en aerolínea US$1.500",
                "code": "16",
                "status": true,
                "translate": [
                    {
                        "language": "EN",
                        "name": "Compensation for lost luggage by airline US$1,500"
                    },
                    {
                        "language": "PT",
                        "name": "Compensação de bagagem perdida na companhia aérea US$ 1.500"
                    }
                ],
                "category": "3-asistence"
            }
        ];
    if (rentersArray.length > 0) {
        if (!rentersArray.some((item) => item === "avis" || item === "budget")) {
            generalDetails = generalDetails.filter((detail) => detail.name !==
                "Sin recargos adicionales para menores de 25 años (21-24 años)");
        }
    }
    const iconMap = {
        [GroupRates.ALL_INCLUSIVE_MAX]: _jsx(IconAllInclusiveMax, {}),
        [GroupRates.BASIC_PLUS]: _jsx(IconBasicPlus, {}),
    };
    const IconComponent = iconMap[myData.groupRate] || null;
    return (_jsxs("section", { className: "detail__qualifiers", children: [_jsx("h5", { className: "qualifiers-title", id: "inclusions_title", children: t("included_in_rate") }), _jsxs("div", { className: "inclusion-list inclusion-list--blocks", children: [_jsx(InclusionListBlock, { iconTitle: _jsx(IconCarInclusions, {}), title: t("general_inclusions_1"), type: "1-insurance", generalDetails: generalDetails, applyDiscount: applyDiscount, hasBorderBottom: false, allInclusiveOffer: allInclusiveOffer }), _jsx(InclusionListBlock, { iconTitle: _jsx(IconAllInclusive, {}), title: t("general_inclusions_2"), type: "2-inclusions", generalDetails: generalDetails, applyDiscount: applyDiscount, hasBorderBottom: false, allInclusiveOffer: allInclusiveOffer }), _jsx(InclusionListBlock, { iconTitle: _jsx(IconTravelInsurance, {}), title: t("general_inclusions_3"), type: "3-asistence", generalDetails: generalDetails, applyDiscount: applyDiscount, hasBorderBottom: false, promoLabel: t("rq_4_1") + todayDate + ", 11:59pm", providedInsurance: true, allInclusiveOffer: allInclusiveOffer })] })] }));
};
export default RateQualifierGeneralDetails;
